import { motion } from 'framer-motion';

const models = [
  {
    title: 'Abogados de Inmigracion',
    subtitle: 'Los abogados pagan por recibir clientes listos para contratar',
    color: 'emerald',
    metrics: [
      { label: 'Plan Emprendedor', value: '149 EUR/sem', sub: '10 clientes cualificados' },
      { label: 'Plan Independiente', value: '249 EUR/sem', sub: '20 clientes cualificados' },
      { label: 'Plan Despacho', value: '499 EUR/sem', sub: '50 clientes cualificados' },
    ],
    highlight: 'Cada abogado genera 12-18x lo que paga. Se paga solo desde la primera semana.',
    mrr: '80,550',
    icon: (
      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z" />
      </svg>
    ),
  },
  {
    title: 'Envio de Dinero',
    subtitle: 'Los migrantes envian dinero a sus familias cada mes. Migro cobra una comision justa.',
    color: 'blue',
    metrics: [
      { label: 'Comision fija por envio', value: '1.50-3.00 EUR', sub: 'por transferencia' },
      { label: 'Margen en el tipo de cambio', value: '0.5-1.0%', sub: '60-75% mas barato que Western Union' },
      { label: 'Ingreso medio por envio', value: '~5 EUR', sub: 'cuando envian 500 EUR a casa' },
    ],
    highlight: 'Ingreso recurrente y predecible: los migrantes envian dinero todos los meses sin falta.',
    mrr: '30,000',
    icon: (
      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z" />
      </svg>
    ),
  },
  {
    title: 'Cuenta Bancaria y Tarjeta',
    subtitle: 'El migrante recibe cuenta espanola y tarjeta el mismo dia que llega, con solo su pasaporte.',
    color: 'purple',
    metrics: [
      { label: 'Cuenta bancaria espanola', value: 'IBAN desde dia 1', sub: 'para cobrar nomina y alquilar piso' },
      { label: 'Tarjeta en Europa', value: 'Visa / Mastercard', sub: 'fisica y virtual, Apple Pay' },
      { label: 'Tarjeta para la familia', value: 'En su pais', sub: 'para que reciban dinero al instante' },
    ],
    highlight: 'Plan gratuito + planes premium desde 4.99 EUR/mes con mejores condiciones.',
    mrr: '13,000',
    icon: (
      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
      </svg>
    ),
  },
  {
    title: 'Agencias de Marketing',
    subtitle: 'Agencias que ya tienen abogados como clientes nos traen nuevos abogados a Migro.',
    color: 'orange',
    metrics: [
      { label: 'Comision por traer abogado', value: '20-25%', sub: 'de su cuota los primeros 6 meses' },
      { label: 'Comision recurrente', value: '15%', sub: 'si la agencia costea publicidad' },
      { label: 'Coste por cliente con agencia', value: '<2 EUR', sub: 'vs 5 EUR si Migro lo hace solo' },
    ],
    highlight: 'Migro crece sin necesitar equipo de ventas propio. Las agencias lo hacen por nosotros.',
    mrr: '—',
    icon: (
      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
      </svg>
    ),
  },
];

const colorClasses: Record<string, { border: string; bg: string; text: string; badge: string }> = {
  emerald: { border: 'border-emerald-400/30', bg: 'bg-emerald-500/20', text: 'text-emerald-400', badge: 'bg-emerald-500/10 text-emerald-400 border-emerald-400/20' },
  blue: { border: 'border-blue-400/30', bg: 'bg-blue-500/20', text: 'text-blue-400', badge: 'bg-blue-500/10 text-blue-400 border-blue-400/20' },
  purple: { border: 'border-purple-400/30', bg: 'bg-purple-500/20', text: 'text-purple-400', badge: 'bg-purple-500/10 text-purple-400 border-purple-400/20' },
  orange: { border: 'border-orange-400/30', bg: 'bg-orange-500/20', text: 'text-orange-400', badge: 'bg-orange-500/10 text-orange-400 border-orange-400/20' },
};

export function RevenueModelCards() {
  return (
    <section id="revenue" className="py-20 md:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5 }}
          className="mb-12 text-center"
        >
          <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-emerald-400">
            Como ganamos dinero
          </span>
          <h2 className="font-display text-3xl font-bold text-white sm:text-4xl">
            4 fuentes de{' '}
            <span className="bg-gradient-to-r from-emerald-400 to-emerald-500 bg-clip-text text-transparent">
              ingresos
            </span>
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-slate-400">
            Cada servicio que ofrecemos al migrante genera un ingreso, y cada ingreso refuerza al siguiente.
          </p>
        </motion.div>

        <div className="grid gap-5 md:grid-cols-2">
          {models.map((m, i) => {
            const c = colorClasses[m.color];
            return (
              <motion.div
                key={m.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.5, delay: 0.1 * i }}
                className={`group rounded-2xl border border-white/10 bg-white/[0.06] p-6 backdrop-blur-md transition hover:${c.border} hover:bg-white/[0.08]`}
              >
                <div className="mb-4 flex items-center gap-3">
                  <div className={`flex h-10 w-10 items-center justify-center rounded-lg ${c.bg} ring-1 ${c.border} ${c.text}`}>
                    {m.icon}
                  </div>
                  <div>
                    <h3 className="font-display text-lg font-bold text-white">{m.title}</h3>
                    <p className="text-xs text-slate-400">{m.subtitle}</p>
                  </div>
                  {m.mrr !== '—' && (
                    <span className={`ml-auto rounded-full border px-3 py-1 text-xs font-semibold ${c.badge}`}>
                      MRR: {m.mrr} EUR
                    </span>
                  )}
                </div>

                <div className="space-y-2">
                  {m.metrics.map(metric => (
                    <div key={metric.label} className="flex items-center justify-between rounded-lg border border-white/5 bg-white/[0.03] px-3 py-2">
                      <div>
                        <span className="text-sm text-slate-300">{metric.label}</span>
                        <span className="ml-1 text-xs text-slate-500">({metric.sub})</span>
                      </div>
                      <span className={`text-sm font-semibold ${c.text}`}>{metric.value}</span>
                    </div>
                  ))}
                </div>

                <div className={`mt-4 rounded-lg border ${c.border} ${c.bg.replace('/20', '/[0.08]')} px-3 py-2`}>
                  <p className="text-xs font-medium text-slate-300">{m.highlight}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
